const VALUES = [
  { icon: 'fa-shield-halved', title: 'RITUAL PURITY', text: 'Every item undergoes authentic Vedic purification.' },
  { icon: 'fa-star', title: 'ENERGIZED ALIGNMENT', text: 'High-precision sync with your personal birth point.' },
  { icon: 'fa-bag-shopping', title: 'GLOBAL DELIVERY', text: 'Clinical logistics ensuring spiritual integrity.' },
]

export default function CoreValuesSection() {
  return (
    <section className="py-20 md:py-24 md:px-20 bg-white border-y border-gray-100 select-none">
      <div className="container px-6 mx-auto max-w-350">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {VALUES.map((v) => (
            <div key={v.title} className="group flex flex-col items-center text-center p-8 bg-[#FAF6F0]/50 hover:bg-white rounded-3xl border border-transparent hover:border-secondary/20 shadow-sm hover:shadow-xl hover:-translate-y-1.5 transition-all duration-500 ease-out">
              <div className="w-14 h-14 rounded-2xl bg-secondary/10 flex items-center justify-center text-secondary border border-secondary/20 group-hover:bg-primary group-hover:text-white group-hover:rotate-6 transition-all duration-500 shadow-inner shrink-0">
                <i className={`fa-solid ${v.icon} text-xl`}></i>
              </div>
              <div className="mt-6 space-y-2">
                <h4 className="text-lg font-bold font-heading text-primary group-hover:text-secondary transition-colors uppercase tracking-wide">{v.title}</h4>
                <div className="w-8 h-px bg-secondary/30 mx-auto group-hover:w-16 transition-all duration-500"></div>
                <p className="text-[10px] text-gray-400 font-bold font-body leading-relaxed uppercase tracking-[0.18em] pt-1">{v.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
